// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import RegistrationStatus from '../state/registration-status';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const RegistrationsReviewStatusCriteria = props => {

    const statusesSelectionMessage = props.registrationStatus.selected.length > 0 ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (

        <section className='registrations-review-status-criteria'>
            <CheckboxListWithLabel
                className='registrations-review-statuses'
                initialState={createHashMap(props.registrationStatus.selected, 'key')}
                isRequired={true}
                label='STATUS'
                list={addCollectionLabels(props.registrationStatus.allowed, 'value')}
                onChange={props.onStatusSelect}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllStatuses}
                type='button'
            >
                <FormattedMessage id={statusesSelectionMessage}/>
            </button>
        </section>

    );

};

RegistrationsReviewStatusCriteria.displayName = 'RegistrationsReviewStatusCriteria';
RegistrationsReviewStatusCriteria.propTypes = {
    onSelectAllStatuses: PropTypes.func.isRequired,
    onStatusSelect: PropTypes.func.isRequired,
    registrationStatus: PropTypes.instanceOf(RegistrationStatus).isRequired
};

export default RegistrationsReviewStatusCriteria;



// WEBPACK FOOTER //
// ./src/reports/registrations-review/components/registrations-review-status-criteria.js